import React from 'react';
import loadingIcon from '../../images/progbar.gif';

export const LoadingAnimation = () => {
    return <div className='loading-animation'>
        <img src={loadingIcon} alt="page is loading" className="loading" />
    </div>;
}